export enum LongSessionError {
    ReachFiveError = 'ReachFiveError',
}
